export const SocialMedia = () => {
  return (
    <div class="inline-flex px-0 text-center">
        <div class="relative inline-block overflow-hidden transition-all transform " role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div class="flex items-center justify-left pt-8 mx-auto text-sky-900 dark:text-white border-gray-200 w-44 text-xl md:text-3xl">
                 <a href="https://www.linkedin.com/in/lhotovy/" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-linkedin px-4 " alt="linkedIn"/>
                 </a>
                 <a href="https://github.com/lhotovy" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-github px-4" alt="gitHub"/>
                 </a>
            </div>
        </div>
    </div>
  )
}
